import { render, staticRenderFns } from "./shangq.vue?vue&type=template&id=4bd3bab9&scoped=true&"
import script from "./shangq.vue?vue&type=script&lang=js&"
export * from "./shangq.vue?vue&type=script&lang=js&"
import style0 from "./shangq.vue?vue&type=style&index=0&id=4bd3bab9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3bab9",
  null
  
)

export default component.exports